// extracted by mini-css-extract-plugin
export default {"modal":"ModalPicture_modal__3Dy8b","modal_content":"ModalPicture_modal_content__XptK2","modal_content__active":"ModalPicture_modal_content__active__bcQPM"};